import React, {Component} from 'react';
import {Button, ListGroup, Modal, ModalBody, ModalHeader, Form, Label, Input, Media} from 'reactstrap';
import {Link} from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
//markdownEditor imports
import { EditorState} from 'draft-js';
import {Editor} from 'react-draft-wysiwyg'
import {stateFromMarkdown} from 'draft-js-import-markdown';
import {stateToMarkdown} from 'draft-js-export-markdown';
import '../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
//
import axios from "axios/index";
import {serverPath, convertDatetime} from "./common";
import ModalAlert from "./ModalAlertComponent";
import logo from '../assets/logo.png';

/*
    @brief: News component renders news on home page or on separate page
    @props: onHome: bool, indicates if component is rendered on home page or on separate one
*/

class News extends Component {
    constructor(props) {
        super(props);

        this.state={
            news:[],
            user:null,
            isModalOpen: false,
            editorState: EditorState.createEmpty(),
            newsToModify: null,
            modalTitle: "",

            //modal alert
            modalAlertOpen: false,
            modalAlertMessage: ""

        };

        this.toggleModal = this.toggleModal.bind(this);
        this.hideModalAlert = this.hideModalAlert.bind(this);

    }

    showModalAlert(message){
        this.setState({
            modalAlertMessage: message,
            modalAlertOpen: true
        });
    }

    hideModalAlert() {
        this.setState({
           modalAlertOpen: false,
           modalAlertMessage: ""
        });
    }

    //clickHandlers
    handleEditNews(news){
        this.toggleModal();

        this.setState({
            editorState:EditorState.createWithContent(stateFromMarkdown(news.text)),
            modalTitle:"Izmeni vest",
            newsToModify:news,
        });

    }
    handleCreateNews(){
        this.toggleModal();
        this.setState({
            modalTitle: "Dodaj vest",
            editorState:EditorState.createEmpty(),
            newsToModify: null,
        });
    }
    handleDeleteNews(news){
        if(window.confirm("Da li ste sigurni da želite da obrišete vest?")){
            var self=this;
            const params = new URLSearchParams();
            params.append('id', news.id);
            params.append('action', 'delete');
            axios.post(serverPath + "newsService.php",params)
                .then(function (response) {
                
                var index = self.state.news.indexOf(news);
                self.state.news.splice(index,1);
                self.setState({
                    news:self.state.news,
                });
            });
        }
    }
    handleDoneButton = () => {
        let md_text=stateToMarkdown(this.state.editorState.getCurrentContent());
      
        //here length of input must be >=3 because stateToMarkdown returns string of length 2 when input is empty
        if(this.title.value.length < 1
        || (md_text.length) < 3){
            this.showModalAlert("Neispavan unos!");
            return;
        }

        const params = new URLSearchParams();
        params.append('title', this.title.value);
        params.append('text', md_text);

       if(this.state.newsToModify !== null) {
           params.append('action' ,'modify');
           params.append('id', this.state.newsToModify.id);
       }
       else{
           params.append('action','create');
       }

        axios.post(serverPath + "newsService.php", params);

       this.toggleModal();
       window.location.reload();
    };

    /*
        @brief: renders plus sign for creating news if admin is logged
     */
    showCreateNewsOption(){
        const showAdminOptions = this.state.user !== null &&
            (this.state.user.roleName === 'administrator' || this.state.user.roleName === "professor");
        if(showAdminOptions){
            return (
                <div className={'row'}>
                    <div className={'col-9'}>
                    </div>
                    <div>
                        <span className={"fa fa-plus ml-4"} onClick={(event) => this.handleCreateNews()}></span>
                    </div>
                </div>
            );
        }
        else{
            return null;
        }

    }
    /*
        @brief:renders edit and delete icons if admin is logged
        @params:
            showAdminOptions:bool, indicates whether to render edit/delete icons or not
            news:news that is currently rendered, user in handler functions
     */
    renderAdminOptions(showAdminOptions, news){
        if(showAdminOptions){
            return(
                <div className={'col'}>
                    <div className={'row'} style={{float: 'right'}}>
                        <span onClick={(event) => this.handleEditNews(news)} className={"fa fa-edit mt-1 mr-1"}></span>
                        <span onClick={(event) => this.handleDeleteNews(news)} className={"fa fa-trash mt-1 ml-1"}></span>
                    </div>
                </div>
            );
        }
        else{
            return (<div></div>);
        }
    }

    /*
        @brief:creates single news as ListGroupItem
        @params:
                news:news to render
                showAdminOptions:bool, indicates whether to render edit/delete icons or not
     */
    createSingleNews(news, showAdminOptions) {
        return (
            <Media>
                <Media left href="#">
                    <Media object src={logo} alt="Generic placeholder image" width={'50px'}/>
                </Media>
                <Media body>
                    <span style={{float: 'right'}}> {convertDatetime(news.datetime).split(" ")[0]} </span>
                    <Media heading>
                        {news.title}
                    </Media>
                    <div className={'row'}>
                        {this.renderAdminOptions(showAdminOptions, news)}
                    </div>
                    <ReactMarkdown source={news.text}/>
                    <br/>
                </Media>
            </Media>
        );
    }
    /*
    @brief displays all news from array
    @params:
        news: array of news, each news has text, title, id and date when its created/modified
        totalNews: number of news pulled from db. used for conditional rendering of button that goes on separate page
     */
    showAllNews(news, totalNews){
        const showAdminOptions = this.state.user !== null && this.state.user.roleName !== 'student';
        if(!this.props.onHome){
            news=news.map((news)=>this.createSingleNews(news, showAdminOptions));
            return(
                <div className={"container"}>
                    <div className={"row mt-2 mb-2"}>

                        <div className={"col-1"}></div>
                        <div className={"col"}>
                            {news}
                        </div>
                        <div className={"col-2"}></div>

                    </div>

                </div>
            );
        }
        else{
            //false because admin options are shown only on separate page
            news=news.map((news)=>this.createSingleNews(news, false));
            return(
                <React.Fragment>
                    <ListGroup>
                        {news}
                    </ListGroup>
                    {(totalNews > 3 || showAdminOptions) &&
                    <Button className={"mt-2"} color="primary" tag={Link} to={"/news"}>Prikaži sva obaveštenja</Button>
                    }
                </React.Fragment>
            );
        }

    };



    onEditorStateChange = (editorState) => {
        this.setState({
            editorState: editorState,
        });
    };

    toggleModal(){
        this.setState({
            isModalOpen:!this.state.isModalOpen
        });
    }
    /*
        @brief: gets data from db on component load
     */
    getData(){
        var self=this;

        //get news
        axios.get(serverPath + "newsService.php", {
            params: {
                action: 'getNews',
                onHome: this.props.onHome,
            }
        }).then(function(response){
            self.setState({
                news:response.data
            });
        });
        //get who is logged in
        axios.get(serverPath + "authService.php",{
            params: {
                action: 'whoIsLoggedIn'
            }
        }).then(function (response) {

            self.setState({
                user:response.data
            });
        })

    }

    componentDidMount(){this.getData()};
    componentWillReceiveProps(newProps){
        this.props=newProps;

    }





    render() {
        // helper variable, used for some debugging, leave it
       /* var news = [
        {id: "1", title: "Naslov1", text: "# Tekst _obaveštenja1_", datetime: "2018-07-24 08:19:18"},
        {id: "2", title: "naslov2", text: "## Tekst ~~obaveštenja2~~", datetime: "2018-07-16 11:12:12"},
        {id: "7", title: "naslov5", text: "neki naslov", datetime: "2018-07-16 06:37:14"},
        {id: "6", title: "naslovz", text: "## Jos neko obavestenje", datetime: "2018-07-09 06:32:32"}
        ];
*/
        var news = this.state.news;
        var newsToDisplay=(this.props.onHome ? news.slice(0,3) : news);

        const {editorState}  = this.state;

        return (
                <React.Fragment>
                    {this.showCreateNewsOption()}
                    {this.showAllNews(newsToDisplay, news.length)}
                    <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal} className={'newsModal'}>
                        <ModalHeader toggle={this.toggleModal}>
                            {this.state.modalTitle}
                        </ModalHeader>
                        <ModalBody>
                            <Form inline>
                                <Label htmlFor={"title"}>Naslov</Label>
                                <Input name={"title"} innerRef={(input) => this.title = input} className={"ml-3 col"}
                                       defaultValue={this.state.newsToModify === null ? "" : this.state.newsToModify.title}/>
                                <Editor
                                    editorState={editorState}
                                    wrapperClassName="wrapper-class"
                                    editorClassName="editor-class"
                                    toolbarClassName="toolbar-class"
                                    onEditorStateChange={this.onEditorStateChange}

                                />
                                <Button onClick={this.handleDoneButton} color="primary" >Gotovo</Button>
                            </Form>
                        </ModalBody>
                    </Modal>

                    <ModalAlert showModal={this.state.modalAlertOpen} message={this.state.modalAlertMessage}
                        closeModalHandler={this.hideModalAlert}/>

                </React.Fragment>
        );
    }
}

export default News